// Sidebar navigation component using Ahua NavigationRail
import { NavigationRail, NavigationItem } from '@yaradigitallabs/ahua-react';
import { Suspense } from 'react';

// Props for Sidebar component
// routes: array of navigation items
// collapsed: sidebar collapsed state
// setCollapsed: function to update collapsed state
// selected: currently selected route url
// setSelected: function to update selected route

type SidebarProps = {
  routes: Array<{
    id: string;
    text: string;
    icon: string;
    selected: boolean;
    url: string;
  }>;
  collapsed: boolean;
  setCollapsed: (collapsed: boolean) => void;
  selected: string;
  setSelected: (selected: string) => void;
};

// Sidebar component renders navigation rail with routes and utility items
const Sidebar = ({
  routes,
  collapsed,
  setCollapsed,
  selected,
  setSelected,
}: SidebarProps) => {
  return (
    // Suspense for lazy loading fallback
    <Suspense fallback={<div>Loading...</div>}>
      <div className="flex min-h-[calc(100vh-60px)]">
        {/* NavigationRail from Ahua library */}
        <NavigationRail
          onChange={value => setCollapsed(value)}
          defaultCollapsed={collapsed}
        >
          {/* Main navigation items */}
          <NavigationRail.Middle>
            {routes.map(item => {
              return (
                <NavigationRail.Item
                  key={item.id}
                  onClick={() => setSelected(item.url)}
                  selected={selected === item.url}
                >
                  <NavigationItem.Head>
                    <NavigationItem.Icon icon={item.icon} />
                  </NavigationItem.Head>
                  {/* Show text only if not collapsed */}
                  {!collapsed && (
                    <NavigationItem.Body>{item.text}</NavigationItem.Body>
                  )}
                </NavigationRail.Item>
              );
            })}
          </NavigationRail.Middle>
          {/* Separator and utility items at the end */}
          <NavigationRail.Separator />
          <NavigationRail.End>
            <NavigationRail.CollapseItem />
            <NavigationRail.Item>
              <NavigationItem.Head>
                <NavigationItem.Icon icon="Settings" />
              </NavigationItem.Head>
              {!collapsed && (
                <NavigationItem.Body size={'s'}>Settings</NavigationItem.Body>
              )}
            </NavigationRail.Item>

            <NavigationRail.Item>
              <NavigationItem.Head>
                <NavigationItem.Icon icon="Privacy" />
              </NavigationItem.Head>
              {!collapsed && (
                <NavigationItem.Body size={'s'}>
                  Privacy Notice
                </NavigationItem.Body>
              )}
            </NavigationRail.Item>
          </NavigationRail.End>
        </NavigationRail>
      </div>
    </Suspense>
  );
};
export default Sidebar;
